import React from 'react';
import Banner from '../components/Banner';
import Header from '../components/Header';
import '../components/css/Seo.css';
import video from '../animation.mp4'; // Ensure this path is correct

const Seo = () => {
    return (
        <>
            <Header />
            <Banner />
            
            <div className='seo'>
                <h1>🚀 Službomat – Zvýšte viditeľnosť vášho podnikania online</h1>

                <p>Chcete, aby si vašu firmu všimlo viac ľudí na internete? Službomat je nástroj, ktorý vám pomôže jednoducho predstaviť vaše služby a pritiahnuť nových zákazníkov.</p>

                <h2>Čo ponúkame?</h2>
                <ul>
                    <li><span className="highlight">Prednostné zobrazovanie vo vyhľadávaní:</span> Získajte výhodu pred konkurenciou v našom vyhľadávaní.</li>
                    <li><span className="highlight">Reklama priamo na stránke:</span> Zvýšte dosah vašich služieb pomocou reklamy priamo na Službomate.</li>
                    <li><span className="highlight">Nahranie aktuálnych informácií:</span> Udržujte svoj profil stále aktuálny – od kontaktov až po otváracie hodiny či cenník.</li>
                    <li><span className="highlight">Fotografie:</span> Pridajte kvalitné fotky vašich služieb a produktov a zaujmite tak viac potenciálnych zákazníkov.</li>

                </ul>

                <p>Podľa štatistík až <span className="highlight">85 % zákazníkov</span> hľadá služby online ešte pred kontaktovaním firmy. Ak nie ste online, strácate zákazníkov. Službomat vás dostane tam, kde vás ľudia hľadajú.</p>

                <video autoPlay loop muted>
                    <source src={video} type="video/mp4" />
                </video>

                


                <h1>🔎 SEO: Zvýšte návštevnosť a predaj</h1>
                <p>SEO zabezpečí, že vaša stránka bude na popredných pozíciách vo vyhľadávačoch ako Google. Čísla hovoria jasne:</p>
                <ul>
                    <li>Prvá stránka Googlu získava až <span className="highlight">92 % všetkých kliknutí</span>.</li>
                    <li>Top 3 výsledky na Googli získavajú <span className="highlight">75 % kliknutí</span>.</li>
                    <li>Organická návštevnosť má o <span className="highlight">14,6 % vyššiu konverziu</span> ako platená reklama.</li>
                </ul>
                <p>Dobre nastavené SEO vám prinesie viac návštevníkov, viac objednávok a nižšie náklady na marketing.</p>

                <h2>Prečo investovať do SEO?</h2>
                <ul>
                    <li><span className="highlight">Nižšie náklady</span> v porovnaní s platenou reklamou.</li>
                    <li><span className="highlight">Dlhodobá udržateľnosť</span> – správne optimalizovaný web prináša stabilné výsledky.</li>
                    <li><span className="highlight">Väčšia dôvera zákazníkov</span> – organické výsledky pôsobia dôveryhodnejšie než reklama.</li>
                </ul>

                <h1>📢 Organická reklama: Efektívna propagácia na sociálnych sieťach</h1>
                <p>Organické príspevky na sociálnych sieťach sú silným nástrojom na budovanie značky:</p>
                <ul>
                    <li><span className="highlight">77 % spotrebiteľov</span> uvádza, že nakupujú od značiek, ktoré sledujú na sociálnych sieťach.</li>
                    <li>Organické príspevky na Instagrame môžu zasiahnuť <span className="highlight">až 30 % sledovateľov</span> aj bez reklamy.</li>
                    <li>Virálne príspevky môžu zvýšiť dosah až o <span className="highlight">500 %</span> bez jedinej investície.</li>
                </ul>
                <p>Kvalitný obsah a aktívna komunikácia so sledovateľmi môžu výrazne zvýšiť povedomie o vašej značke.</p>

                <h2>Prečo investovať do organickej reklamy?</h2>
                <ul>
                    <li><span className="highlight">Bezplatná propagácia</span> – ak je obsah zaujímavý, ľudia ho šíria sami.</li>
                    <li><span className="highlight">Lepšia interakcia</span> so zákazníkmi.</li>
                    <li><span className="highlight">Dlhodobý efekt</span> – stabilná komunita prináša verných zákazníkov.</li>
                </ul>
                <p>Ak chcete posunúť svoje podnikanie na vyššiu úroveň, investujte do <span className="highlight">SEO optimalizácie</span> a <span className="highlight">organickej reklamy na sociálnych sieťach</span>. Určite sa to oplatí!</p>
                
                
                {/* <div className='vizitka'>
                    <p>Kontaktujte nás:</p>
                    <p>📞 <a href="tel:0908 482 517">0908 482 517</a></p>
                    <p>✉️ <a href="mailto:info@sluzbomat.sk">info@sluzbomat.sk</a></p>
                </div> */}
                
            </div>
            
        </>
    );
};

export default Seo;
